import { render, staticRenderFns } from "./communicationDashboardParty.vue?vue&type=template&id=3785de6c&scoped=true"
import script from "./communicationDashboardParty.vue?vue&type=script&lang=js"
export * from "./communicationDashboardParty.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardParty.vue?vue&type=style&index=0&id=3785de6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785de6c",
  null
  
)

export default component.exports